import React, {FC, ReactNode, useEffect, useRef, useState} from 'react';
import {Popover, Whisper} from 'rsuite';
import cn from 'classnames';

import styles from './MoreActions.module.scss';

import type { WhisperProps } from 'rsuite';


type Placement = WhisperProps['placement'];


interface IMoreActionsProps {
    children: ReactNode | null | undefined,
    // eslint-disable-next-line no-undef
    anchor: JSX.Element,
    arrow?: boolean,
    placement?: Placement;
}

const MoreActions: FC<IMoreActionsProps> = ({children, anchor, arrow, placement = 'autoVertical'}) => {
    const whisperRef = useRef<any>();
    const [isOpen, setIsOpen] = useState(false);

    const closeDropdown = () => {
        if (whisperRef.current && typeof whisperRef.current.close === 'function') {
            whisperRef.current.close();
        }
    };

    useEffect(() => {
        const handleGlobalClick = (e: MouseEvent) => {
            const target = e.target as HTMLElement;
            if (target.closest('[data-modal-trigger]')) {
                closeDropdown();
            }
        };

        document.addEventListener('click', handleGlobalClick);
        return () => document.removeEventListener('click', handleGlobalClick);
    }, []);

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        event.preventDefault();
        event.stopPropagation();
    };

    const childrenWithCloseHandler = React.Children.map(children, (child) => {
        if (React.isValidElement(child)) {
            return React.cloneElement(child as React.ReactElement<any>, {
                onClick: (e: React.MouseEvent) => {
                    closeDropdown();
                    if (child.props.onClick) {
                        child.props.onClick(e);
                    }
                },
            });
        }
        return child;
    });

    const typePopover = <Popover arrow={arrow ?? true}>
        <div className={styles['dropdown']}>
            {childrenWithCloseHandler}
        </div>
    </Popover>;

    return (
        <Whisper
            ref={whisperRef}
            placement={placement}
            trigger="click" speaker={typePopover}
            onOpen={() => setIsOpen(true)}
            onClose={() => setIsOpen(false)}
        >
            <div className={cn(isOpen && styles.triggerOpen)} onClick={handleClick}>
                {anchor}
            </div>
        </Whisper>
    );
};

export default React.memo(MoreActions);